import { v4 as uuidv4 } from "uuid";

function chillHop(){
    return [
        {
        name : "Higher",
        artist: "Misha, Jussi Halme",
        cover: "https://chillhop.com/wp-content/uploads/2021/05/2473c60e471fe9b40e246bf7711c87d3d6ea69a7-1024x1024.jpg",
        id: uuidv4(),
        active: true,
        color: ["#F07A78", "#2E395A"],
        audio: "https://mp3.chillhop.com/serve.php/?mp3=15088",
        },
        {
        name : "travelbag",
        artist: "mommy, Sleepy Fish",
        cover: "https://chillhop.com/wp-content/uploads/2021/05/1245c0271290a3196328c0cf4aaa910cd873dfe7-1024x1024.jpg",
        id: uuidv4(),
        active: false,
        color: ["#5D8FD2", "#F7D7C8"],
        audio: "https://mp3.chillhop.com/serve.php/?mp3=19058",
        },
        {
        name : "Lavish",
        artist: "Misha, Jussi Halme",
        cover: "https://chillhop.com/wp-content/uploads/2021/05/732128e1da8fd5f6292ffc1926a2ea840a54f4d0-1024x1024.jpg",
        id: uuidv4(),
        active: false,
        color: ["#24344D", "#F9F9F9"],
        audio: "https://mp3.chillhop.com/serve.php/?mp3=17933",
        },
        {
        name : "Dive",
        artist: "Evil Needle",
        cover: "https://chillhop.com/wp-content/uploads/2021/04/cb0cc6270d7f2e1bb13e44e8832bd5c9b2a61080-1024x1024.jpg",
        id: uuidv4(),
        active: false,
        color: ["#EA9B54", "#658390"],
        audio: "https://mp3.chillhop.com/serve.php/?mp3=17089",
        },
        {
        name : "Canary Forest",
        artist: "Aso, Middle School, Aviino",
        cover: "https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg",
        id: uuidv4(),
        active: false,
        color: ["#E0B16F", "#1D6562"],
        audio: "https://mp3.chillhop.com/serve.php/?mp3=10075",
        },
        {
        name : "Caravan",
        artist: "goosetaf, The Field Tapes, Makzo",
        cover: "https://chillhop.com/wp-content/uploads/2021/06/23b2ff959731b56ea8545828b462311e8b1a2bcc-1024x1024.jpg",
        id: uuidv4(),
        active: false,
        color: ["#224EB6", "#ECC0B4"],
        audio: "https://mp3.chillhop.com/serve.php/?mp3=20122",
        },
        {
        name : "Daylight",
        artist: "Aiguille",
        cover: "https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg",
        id: uuidv4(),
        active: false,
        color: ["#F4B0AD", "#4D417D"],
        audio: "https://mp3.chillhop.com/serve.php/?mp3=9272",
        },
        {
        name : "Lonely Waves",
        artist: "C Y G N",
        cover: "https://chillhop.com/wp-content/uploads/2021/02/80be32197ca7971424bef5e4d0c6810e1d4334c6-1024x1024.jpg",
        id: uuidv4(),
        active: false,
        color: ["#30294A", "#ECA2F8"],
        audio: "https://mp3.chillhop.com/serve.php/?mp3=14981",
        },
        {
        name : "Going Back",
        artist: "Swørn",
        cover: "https://chillhop.com/wp-content/uploads/2020/10/737bb830d34592344eb4a2a1d2c006cdbfc811d9-1024x1024.jpg",
        id: uuidv4(),
        active: false,
        color: ["#E6D6E0", "#304E59"],
        audio: "https://mp3.chillhop.com/serve.php/?mp3=10310",
        },
        {
        name : "Sleepover",
        artist: "Nymano, JK the Sage",
        cover: "https://chillhop.com/wp-content/uploads/2020/09/09fb436604242df99f84b9f359acb046e40d2e9e-1024x1024.jpg",
        id: uuidv4(),
        active: false,
        color: ["#5C5389", "#A1738F"],
        audio: "https://mp3.chillhop.com/serve.php/?mp3=10130",
        },      
    ];
}

export default chillHop;
